var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'loading-spinner d-flex align-items-center ',
    _vm.size,
    { 'justify-content-center': _vm.align === 'center' },
    { 'justify-content-start': _vm.align === 'left' },
    { 'justify-content-end': _vm.align === 'right' },
    { 'flex-column': _vm.message && _vm.stacked },
  ]},[_c('div',{staticClass:"loader"}),_vm._v(" "),(_vm.message)?_c('span',{class:[_vm.stacked ? 'mt-3' : 'ml-2']},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }